import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Button from '../../../components/common/Button';
import { BANNER_HEADER_IMAGE, BANNER_HEADER_TEXT } from '../../../modules/cms/reducer';
import { open } from '../../../modules/modal/actions';
import { openOnlineLinkModal } from '../../../modules/analytics/actions';

export const BigBanner = ({ headerType, headerTitle, headerTextColor, headerImage, backgroundColor, offerText, subText, additionalText, image, backUp, ctaButtonText, ctaButtonTextColor, ctaButtonBackgroundColor, ctaUrl, ctaTarget, kqcText, termsText, termsTextColor, termsUrl, openLoginModal, openRegistrationModal, analyticsOpenOnlineLinkModal, history }) => {
  const showRegistration = () => {
    analyticsOpenOnlineLinkModal('Registration');
    openRegistrationModal();
  };

  const showLogin = () => {
    analyticsOpenOnlineLinkModal('Login');
    openLoginModal();
  };

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    switch (ctaUrl) {
      case 'showRegistration': {
        showRegistration();
        break;
      }
      case 'showLogin': {
        showLogin();
        break;
      }
      default: {
        if (ctaTarget === '_self' && ctaUrl.match(/^\//)) {
          history.push(ctaUrl);
          return false;
        }
        window.open(ctaUrl, ctaTarget);
      }
    }
    return false;
  };

  return (
    <div className="big-banner" style={{ backgroundColor }}>
      <div className="big-banner__section-top">
        {(headerType === BANNER_HEADER_TEXT && headerTitle) && (
          <p className="big-banner__paragraph" style={{ color: headerTextColor }}>
            {headerTitle}
          </p>
        )}
        {(headerType === BANNER_HEADER_IMAGE && headerImage) && (
          <div className="big-banner__header-logo-container">
            <img className="big-banner__header-logo" src={headerImage} />
          </div>
        )}
        {offerText && <div className="big-banner__header" dangerouslySetInnerHTML={{ __html: offerText }} />}
        {subText && <div className="big-banner__subtitle" dangerouslySetInnerHTML={{ __html: subText }} />}
        {additionalText && <div className="big-banner__subtitle" dangerouslySetInnerHTML={{ __html: additionalText }} />}
      </div>

      <div className="big-banner__image-container">
        <img
          className="big-banner__image"
          src={image}
          onError={(e) => { e.target.src = backUp; }}
        />
      </div>

      {(ctaButtonText || kqcText || termsText) && (
        <div className="big-banner__section-bottom">
          {ctaButtonText && (
            <Button className="big-banner__button" style={{ color: ctaButtonTextColor, backgroundColor: ctaButtonBackgroundColor }} onClick={handleClick}>
              {ctaButtonText}
            </Button>
          )}
          {kqcText && <div className="big-banner__disclaimer" dangerouslySetInnerHTML={{ __html: kqcText }} />}
          {termsText && (
            <p className="big-banner__disclaimer">
              <a
                href={termsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="big-banner__link"
                style={{
                  color: termsTextColor
                }}
              >
                {termsText}
              </a>
            </p>
          )}
        </div>
      )}
    </div>
  );
};

BigBanner.propTypes = {
  additionalText: PropTypes.string,
  analyticsOpenOnlineLinkModal: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string,
  ctaButtonBackgroundColor: PropTypes.string,
  ctaButtonText: PropTypes.string,
  ctaButtonTextColor: PropTypes.string,
  ctaTarget: PropTypes.string,
  ctaUrl: PropTypes.string,
  headerImage: PropTypes.string,
  headerTextColor: PropTypes.string,
  headerTitle: PropTypes.string,
  headerType: PropTypes.string,
  history: PropTypes.object.isRequired,
  image: PropTypes.string,
  backUp: PropTypes.string,
  kqcText: PropTypes.string,
  offerText: PropTypes.string,
  openLoginModal: PropTypes.func.isRequired,
  openRegistrationModal: PropTypes.func.isRequired,
  subText: PropTypes.string,
  termsText: PropTypes.string,
  termsTextColor: PropTypes.string,
  termsUrl: PropTypes.string,
};

const mapDispatchToProps = {
  openLoginModal: open.bind(null, {
    componentName: 'LinkAccountTerms',
    componentProps: {
      contentToDisplay: 'login'
    }
  }),
  openRegistrationModal: open.bind(null, {
    componentName: 'LinkAccountTerms',
    componentProps: {
      contentToDisplay: 'registration'
    }
  }),
  analyticsOpenOnlineLinkModal: openOnlineLinkModal
};

export default withRouter(connect(null, mapDispatchToProps)(BigBanner));
